const TeamActionTypes = {
    SET_CAPTAIN_ID: "SET_CAPTAIN_ID",
    ADD_OTHER_TEAMS: "ADD_OTHER_TEAMS",
    SET_TEAM_NAME: "SET_TEAM_NAME",
};

export default TeamActionTypes;